/*
 * @Description: 实时定位驾驶舱 — B3「单成员完整轨迹」本地 mock（个人轨迹回放用）
 *   覆盖 起 / 移动(实线) / 停留 / 拍照 / 中断(虚线,无 points) / 当前 各类节点。
 *   坐标在成都高新一带，时间基于 MOCK_NOW_MS 确定性生成。
 */
import { MOCK_NOW_MS } from '../constants'
import { TimelineData } from '../types/cockpit.types'

const H = 60 * 60 * 1000
const M = 60 * 1000

/** 单成员当日完整轨迹 mock */
export function getMockTimeline(): TimelineData {
  const t0 = MOCK_NOW_MS - 6 * H // 当日活动起点

  return {
    summary: {
      totalDistanceMeters: 8400,
      totalDurationSec: Math.round(5.2 * 3600),
      stayPointCount: 6,
      photoCount: 23,
      pointCount: 1200
    },
    startLocation: {
      time: t0,
      lng: 104.061,
      lat: 30.578,
      address: '成都市高新区天府大道北段'
    },
    currentLocation: {
      time: MOCK_NOW_MS,
      lng: 104.072,
      lat: 30.553,
      address: '成都市高新区世纪城路',
      updatedSecAgo: 60
    },
    events: [
      {
        type: 'start',
        time: t0,
        lng: 104.061,
        lat: 30.578,
        address: '成都市高新区天府大道北段'
      },
      {
        type: 'move',
        startTime: t0,
        endTime: t0 + 40 * M,
        durationSec: 2400,
        distanceM: 692,
        lineType: 'solid',
        points: [
          { location: '104.0610,30.5780', locateTime: t0 },
          { location: '104.0625,30.5760', locateTime: t0 + 20 * M },
          { location: '104.0640,30.5720', locateTime: t0 + 40 * M }
        ]
      },
      {
        type: 'stay',
        time: t0 + 40 * M,
        lng: 104.064,
        lat: 30.572,
        address: '成都市高新区上地三街',
        stayDurationSec: 1800
      },
      {
        type: 'move',
        startTime: t0 + 70 * M,
        endTime: t0 + 115 * M,
        durationSec: 2700,
        distanceM: 2600,
        lineType: 'solid',
        points: [
          { location: '104.0640,30.5720', locateTime: t0 + 70 * M },
          { location: '104.0660,30.5680', locateTime: t0 + 95 * M },
          { location: '104.0680,30.5650', locateTime: t0 + 115 * M }
        ]
      },
      {
        type: 'stay',
        time: t0 + 115 * M,
        lng: 104.068,
        lat: 30.565,
        address: '成都市高新区新通大道新怡花园A区',
        stayDurationSec: 1800,
        photoCount: 10,
        photos: [
          {
            smallUrl: 'https://picsum.photos/seed/r1/80/80',
            largeUrl: 'https://picsum.photos/seed/r1/400/400'
          },
          { smallUrl: 'https://picsum.photos/seed/r2/80/80' },
          { smallUrl: 'https://picsum.photos/seed/r3/80/80' }
        ]
      },
      {
        // 中断段：1 小时 24 分钟未能获取轨迹（无 points）
        type: 'move',
        startTime: t0 + 145 * M,
        endTime: t0 + 229 * M,
        lineType: 'dashed',
        gapDurationSec: 84 * 60
      },
      {
        type: 'move',
        startTime: t0 + 229 * M,
        endTime: t0 + 274 * M,
        durationSec: 2700,
        distanceM: 2600,
        lineType: 'solid',
        points: [
          { location: '104.0700,30.5600', locateTime: t0 + 229 * M },
          { location: '104.0710,30.5570', locateTime: t0 + 252 * M },
          { location: '104.0720,30.5530', locateTime: t0 + 274 * M }
        ]
      },
      {
        type: 'current',
        time: MOCK_NOW_MS,
        lng: 104.072,
        lat: 30.553,
        address: '成都市高新区世纪城路',
        updatedSecAgo: 60
      }
    ]
  }
}
